<div class="row mt-2 no-gutters">
  <div class="col">
    <small (click)="showSearchResult = false" *ngIf="accountCategory== 'RENTAL_FLEET'">
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Usage&nbsp;</a>
    </small>
    <small (click)="showSearchResult = false" *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'">
      <a [routerLink]="['/commercial-fleet']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Usage&nbsp;</a>
    </small>
    <small (click)="showSearchResult = false" *ngIf="accountType == 'VEHICLE_SERVICE_PROVIDER'">
      <a [routerLink]="['/service-provider/dashboard']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/service-provider/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Usage&nbsp;</a>
    </small>
    <small (click)="showSearchResult = false" *ngIf="accountCategory== 'DEALER'">
      <a [routerLink]="['/dealer']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Usage&nbsp;</a>
    </small>
    <small (click)="showSearchResult = false" *ngIf="accountCategory== 'CORPORATE' || accountCategory == 'FINANCING_GROUP'">
      <a [routerLink]="['/corporate']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Usage&nbsp;</a>
    </small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="searchResult.onNavSearchClick()"> / Search</a>
    </small>
  </div>
</div>

<div *ngIf="showSearchResult" class="row mt-2 no-gutters">
  <div class="col-12">
    <app-search-results [usageList]="searchedUsageList" [locationMap]="locationMap" #searchResult></app-search-results>
  </div>
</div>

<div *ngIf="!showSearchResult">
  <div class="col-sm-12 card bg-light p-2 mt-3">
    <div class="text-secondary mb-2 font13-400">Please select time period for which you want to
      view Service Usage</div>
    <div>
      <label>Select Period:&nbsp;&nbsp;</label>
      <select id="loc" class="date-dropown" [(ngModel)]="selectedSelectionRange"
        (change)="onChargingPeriodChange($event.target.selectedIndex)" name="selectionOption"
        #selectionOption="ngModel">
        <option *ngFor="let dateRange of chargingPeriodOptions; let i = index;" [ngValue]="dateRange">
          {{dateRange.periodName}}
        </option>
      </select>
      <label *ngIf="selectedFromDate && selectedToDate && selectedPeriod == 0" class="ml-2">({{selectedFromDate | date: utilService.countryData.dateFormat : utilService.countryData.timezone}} -
        {{selectedToDate | date: utilService.countryData.dateFormat : utilService.countryData.timezone}})</label>
    </div>
  </div>

  <div class="col-12 mb-3 no-gutters">
    <app-view-service-usage [usageData]="usageData" [remoteServicesApiReqPayload]="remoteServicesApiReqPayload" [locationMap]="locationMap"></app-view-service-usage>
  </div>
</div>